module.exports = __webpack_public_path__ + "static/media/bb1.efd49517.png";